import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { DividendDetailResolver } from '../core/resolver/dividend-detail-resolver';
import { DividendHomeResolver } from '../core/resolver/dividend-home-resolver';
import { DividendStockResolver } from '../core/resolver/dividend-stock-resolver';
import { DividendYearResolver } from '../core/resolver/dividend-year-resolver';
import { DetailComponent } from './detail/detail.component';
import { DividendComponent } from './dividend.component';
import { HomeComponent } from './home/home.component';
import { StockComponent } from './stock/stock.component';
import { YearComponent } from './year/year.component';



const routes1: Routes = [
  { path: '', component: DividendComponent ,
  children: [    
    { path: 'stock/:year/:code',data: { revalidate: 30 },resolve: { dividendStockResolver: DividendStockResolver  }, component: StockComponent},
    { path: 'year/:year/:month',data: { revalidate: 30 },resolve: { dividendYearResolver: DividendYearResolver  }, component: YearComponent},
    { path: 'year/:year',data: { revalidate: 30 },resolve: { dividendYearResolver: DividendYearResolver  }, component: YearComponent},
    { path: ':id',data: { revalidate: 30 },resolve: { dividendDetailResolver: DividendDetailResolver  }, component: DetailComponent},
    { path: '',resolve: { dividendHomeResolver: DividendHomeResolver  }, component: HomeComponent}
  ] }
];
@NgModule({
  imports: [RouterModule.forChild(routes1)],
  exports: [RouterModule]
})
export class DividendRoutingModule { }
